<template>
  <b-modal
    id="web-class-modal"
    size="lg"
    scrollable
    class="mx-auto"
    hide-footer
    dialog-class="mx-auto"
  >
    <template v-slot:modal-title>
      <h4 class="text-primary mt-5">
        {{ trans("streams.dashboard.web_class_modal.modal_title") }}
      </h4>
    </template>

    <h5>{{ webClassData.title }}</h5>
    <small class="text-bold">{{ webClassData.session_length }}</small>
    <div class="d-flex">
      <small class="mr-3">🗓 {{ session.date }}</small>
      <small class="mb-0">🕑 {{ session.time }}</small>
    </div>
    <small>{{ trans("streams.dashboard.web_class_modal.cant_attend") }}*</small>
    <vue-markdown :source="webClassData.description" />
    <div class="py-3">
      <small class="text-bold">{{ trans("streams.dashboard.web_class_modal.speaker") }}</small>
      <div
        class="d-flex align-items-center"
        v-for="speaker in webClassData.speakers"
        v-if="webClassData.speakers.length > 0"
        :key="speaker.id"
      >
        <b-avatar :src="speaker.image[0].url" size="3rem" v-if="speaker.image.length > 0" />
        <div class="d-block pl-2">
          <p class="text-bold mb-0">{{ speaker.name }}</p>
          <p class="mb-0">{{ speaker.title }} - {{ speaker.company }}</p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="secondary" type="grow" />
    </div>

    <div v-else>
      <web-class-statistics v-if="statistics" :statistics="statistics" />
      <h5 class="py-4">{{ trans("streams.dashboard.web_class_modal.register_title") }}</h5>
      <web-class-registration
        :questions="questions"
        :web-class-id="webClassData.id"
        :session-id="session.sessionId"
        @registrationComplete="onRegistrationCompleted"
      />
    </div>
  </b-modal>
</template>

<script>
import VueMarkdown from "vue-markdown";
import WebClassStatistics from "./web-classes/WebClassStatistics";
import WebClassRegistration from "./web-classes/WebClassRegistration";
import { mapActions } from "vuex";

export default {
  name: "WebClassModal",
  components: { WebClassRegistration, WebClassStatistics, VueMarkdown },
  props: {
    webClassData: Object,
  },
  data() {
    return {
      loading: true,
      statistics: null,
      questions: null,
    };
  },
  mounted() {
    this.getDetails();
  },
  computed: {
    session() {
      return this.webClassData.session;
    },
  },
  methods: {
    ...mapActions({
      loadStream: "streams/loadStream",
    }),
    onRegistrationCompleted() {
      this.loadStream(this.$route.params.id);
    },
    getDetails() {
      this.loading = true;
      this.$axios
        .get(
          `/api/rest/streams/${this.$route.params.id}/webClass/${this.webClassData.id}/${this.webClassData.session.sessionId}`
        )
        .then((res) => {
          this.statistics = res.data.statistics;
          this.questions = [...res.data.questions];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
  watch: {
    webClassData: function () {
      this.getDetails();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-dialog {
  height: 680px;
  display: flex;

  .modal-content {
    padding: 10px 15px;
  }

  .modal-footer {
    justify-content: flex-end;
  }

  @media (max-width: 1024px) {
    height: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;

    .modal-content {
      border: none;
      border-radius: 0px;
      height: 100%;
      overflow: auto;
      max-height: 100%;
    }
    &.modal-dialog-scrollable {
      max-height: 100%;
    }
  }

  .modal-body {
    margin-bottom: 16px;
  }
}
</style>
